export default __webpack_public_path__ + "static/media/linkedin.d7f29e6a.png";